module.exports = __webpack_public_path__ + "img/39.f47f9d74.png";